import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch} from 'react-redux';
import { getOrdinals } from '../../util/api'
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Input,
  Spinner
} from "@material-tailwind/react";
import { useTranslation } from 'react-i18next';

import InscriptionCard from '../InscriptionCard';
import { v4 as uuidv4 } from 'uuid';
import { getUnisatBrc20 } from '../../util/api';
import { getUnisatRunes } from '../../util/api';
import { getBitcoinBalance } from '../../util/bitcoin';
import { getStampBalance, getSrc20Balance, getSrc101Balance } from '../../util/stamp-api';
import { getBitmapByAddress } from '../../util/bitmap-api';
import { getDust20Balance } from '../../util/dust20-api';
import { getTapTokenBalance } from '../../util/tap-api';
import { getUnatByAddress } from '../../util/tap-api';
import { getExtraAddressTokenList } from '../../util/extra';
import { useLocation } from 'react-router-dom';
import { getLRC20TokenBalance } from '../../util/lamda-api';
import { getAlkanesAddressOutput } from '../../util/alkanes-api';
import { getOp20Balance } from '../../util/op20-api';

import brc20Img from '../../assets/imgs/brc20.png';
import runesImg from '../../assets/imgs/runes.png';
import btcImg from '../../assets/imgs/logo.png';
import stampImg from '../../assets/imgs/stamp.jpg'
import src20Img from '../../assets/imgs/src20.jpg'
import BitnameProImage from '../../assets/imgs/bitnamepro.jpg'
import tapImg from '../../assets/imgs/tap.png'
import unatImg from '../../assets/imgs/unat.png'
import bitmapImg from '../../assets/imgs/bitmap.png'
import arc20Img from '../../assets/imgs/atomical.jpg'
import lrc20Img from '../../assets/imgs/lrc20.jpg'
import alkanesImg from '../../assets/imgs/alkanes-logo.png'
import op20Img from '../../assets/imgs/op20.png'

export default function ALL(props) {
  const { keyAddress, handleClick } = props;

  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [brc20Total, setBrc20Total] = useState(0);
  const [runesTotal, setRunesTotal] = useState(0);
  const [stampTotal, setStampTotal] = useState(0);
  const [src20Total, setSrc20Total] = useState(0);
  const [bitmapTotal, setBitmapTotal] = useState(0);
  const [dust20Total, setDust20Total] = useState(0);
  const [src101Total, setSrc101Total] = useState(0);
  const [arc20Total, setArc20Total] = useState(0);
  const [unatTotal, setUnatTotal] = useState(0);
  const [tapTotal, setTapTotal] = useState(0);
  const [lrc20Total, setLrc20Total] = useState(0);
  const [bitcoinBalance, setBitcoinBalance] = useState(0);
  const [alkanesTotal, setAlkanesTotal] = useState(0);
  const [op20Total, setOp20Total] = useState(0);
  const [limit, setLimit] = useState(12);
  const [page, setPage] = useState(1);
  const [ordinals, setOrdinals] = useState([]);

  useEffect(() => {
    fetchAllBrc20();
    fetchAllRunes();
    fetchBitcoinBalance();
    fetchAllstamp();
    fetchAllSrc20();
    fetchAllBitmap();
    fetchAllDust20();
    fetchAllSrc101();
    fetchAllUnat();
    fetchAllTap();
    fetchAllArc20();
    fetchAllLrc20();
    fetchAllAlkanes();
    fetchAllOp20();
  }, [keyAddress])

  const fetchAllAlkanes = async() => {
    if (keyAddress == "") {
      setAlkanesTotal(0);
      return;
    }
    setLoading(true);
    try{
      let data = await getAlkanesAddressOutput(keyAddress);
      setAlkanesTotal(data.length);
    }
    catch(e) {
      setAlkanesTotal(0);
    }
    setLoading(false);
  }

  const fetchAllOp20 = async() => {
    if (keyAddress == "") {
      setOp20Total(0);
      return;
    }

    setLoading(true);
    try{
      let data = await getOp20Balance(keyAddress, 1, 10);
      setOp20Total(data.data.length);
    }
    catch(e) {
      setOp20Total(0);
    }
    setLoading(false);
  }

  const fetchAllLrc20 = async() => {
    if (keyAddress == "") {
      setLrc20Total(0);
      return;
    }
    setLoading(true);
    try{
      let temp = await getLRC20TokenBalance(keyAddress);
      const results = Object.entries(temp).map(([tick, amt]) => ({ tick, amt }));
      const count = results.filter(result => result.amt > 0).length;
      setLrc20Total(count);
    }
    catch(e) {
      setLrc20Total(0);
    }
    setLoading(false);
  }

  const fetchAllArc20 = async() => {
    if (keyAddress == "") {
      setArc20Total(0);
      return;
    }
    
    setLoading(true);
    try{
      let data = await getExtraAddressTokenList(1, 1, "BTC", keyAddress, "arc20");
      if (data.data == undefined) {
        setArc20Total(0);
      }
      else {
        setArc20Total(data.data[0].totalPage); 
      }
    }
    catch(e) {
      setArc20Total(0); 
    }
    setLoading(false);
  }


  const fetchAllTap = async() => {
    if (keyAddress == "") {
      setTapTotal(0);
      return;
    }
    setLoading(true);
    try{
      let data = await getTapTokenBalance(keyAddress, 10, 0);
      setTapTotal(data.total);
    }

    catch(e) {
      setTapTotal(0);
    }
    setLoading(false);
  }

  const fetchAllUnat = async() => {
    
    if (keyAddress == "") {
      setUnatTotal(0);
      return;
    }
    setLoading(true);
    try{
      let data = await getUnatByAddress(keyAddress, 10, 0);
      setUnatTotal(data.sys.elements);
    }
    catch(e) {
      console.log(e);
      setUnatTotal(0);
    }
    setLoading(false);
  }

  const fetchAllSrc101 = async() => {
    if (keyAddress == "") {
      setSrc101Total(0);
      return;
    }
    setLoading(true);
    try{
      let data = await getSrc101Balance(keyAddress, 10, 1);
      setSrc101Total(data.total);
    }
    catch(e) {
      setSrc101Total(0);
    }
    setLoading(false);
  } 


  const fetchAllDust20 = async() => {
    if (keyAddress == "") {
      setDust20Total(0);
      return;
    }
    setLoading(true);
    try{
      let data = await getDust20Balance(keyAddress, 1, 10);
      setDust20Total(data.total);
    }
    catch(e) {
      setDust20Total(0);
    }
    setLoading(false);
  }

  const fetchAllBitmap = async() => {
    if (keyAddress == "") {

      setBitmapTotal(0);
      return;
    }
    setLoading(true);
    
    try{
      let res = await getBitmapByAddress(keyAddress, 10, 0);
      setBitmapTotal(res.data.count)
    }
    catch(e) {
      setBitmapTotal(0);
    }
    setLoading(false);
  }

  const fetchAllSrc20 = async() => {
    if (keyAddress == "") {
      setSrc20Total(0);
      return;
    }

    setLoading(true);
    try{
      let data = await getSrc20Balance(keyAddress, 10, 1);
      if (data.data == undefined) {
        setSrc20Total(0);
      }

      else {
        if (data.pagination != undefined) {
            if (data.pagination.total == null) setSrc20Total(0)
            else setSrc20Total(data.pagination.total);
        }
        else {
            if (data.total == null) setSrc20Total(0)
            else setSrc20Total(data.total); 
        }
      }
    }
    catch(e) {
      setLoading(false);
    }
    setLoading(false);
  }

  const fetchAllstamp = async() => {
    if (keyAddress == "") {
      setStampTotal(0);
      return;
    }

    setLoading(true);
    try{
      let data = await getStampBalance(keyAddress, 10, 1);
      if (data.data == undefined) {
        setStampTotal(0);
      }
      else {
        if (data.pagination != undefined) {
            if (data.pagination.total == null) setStampTotal(0)
            else setStampTotal(data.pagination.total);
        }
        else {
            if (data.total == null) setTotal(0)
            else setStampTotal(data.total); 
        }
        
      }
    }
    catch(e) {
      console.log(e);
      setLoading(false);
    }
    setLoading(false);
  }

  const fetchBitcoinBalance = async () => {
    if (keyAddress == "") {
      setBitcoinBalance(0);
      return;
    }

    setLoading(true);
    try {
      const balance = await getBitcoinBalance(keyAddress);
      setBitcoinBalance(balance);
    } catch (e) {
      console.error('Error fetching BTC balance:', e);
    }
    setLoading(false);
  };

  const fetchAllBrc20 = async() => {
    if (keyAddress == "") {
      setBrc20Total(0);
      return;
    }

    setLoading(true);
    try{
      let data = await getUnisatBrc20(keyAddress, 0, 10);
      setBrc20Total(data.total);
    }
    catch(e) {
      setLoading(false);
    }

    setLoading(false);
  }

  const fetchAllRunes = async() => {
    if (keyAddress == "") {
      setRunesTotal(0);
      return;
    }

    setLoading(true);
    try{
      let data = await getUnisatRunes(keyAddress, 0, 10);
      setRunesTotal(data.total);
    }
    catch(e) {
      setLoading(false);
    }

    setLoading(false);
  }

  return (
    <div className="flex flex-col w-full">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      <div className="md:mt-8 mt-6 grid 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-4 grid-cols-2 gap-3 w-full">
      <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center" 
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={btcImg} alt="brc20" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              BTC 
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { bitcoinBalance } 
          </div>
        </div>
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            handleClick(1)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={brc20Img} alt="brc20" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">

              BRC-20 
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { brc20Total } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            handleClick(5)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={runesImg} alt="runes" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              RUNES
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { runesTotal } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(10)
            else
              handleClick(8)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={stampImg} alt="runes" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              STAMPS
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { stampTotal } 
          </div>
        </div>

      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(9)
            else
              handleClick(7)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={src20Img} alt="runes" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              SRC-20
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { src20Total } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(15)
            else
              handleClick(13)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={BitnameProImage} alt="runes" className="w-8 h-8 rounded-full" />
            <div className="text-white md:text-2xl text-xl font-bold">
              DOMAINS
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { src101Total } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            handleClick(2)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={tapImg} alt="tap" className="w-8 h-8 rounded-full" />
            <div className="text-white md:text-2xl text-xl font-bold">
              TAP
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { tapTotal } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            handleClick(4)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={unatImg} alt="unat" className="w-8 h-8 rounded-full" />
            <div className="text-white md:text-2xl text-xl font-bold">
              UNAT
            </div> 

          </div>
          <div className="text-3xl text-primary font-bold">
             { unatTotal } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(12)
            else
              handleClick(11)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={bitmapImg} alt="bitmap" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              BITMAP
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
            { bitmapTotal } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(13)
            else
              handleClick(12)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={arc20Img} alt="bitmap" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              ARC-20
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { arc20Total } 
          </div>
        </div>
      }
      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(11)
            else
              handleClick(10)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={lrc20Img} alt="bitmap" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              LRC-20
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { lrc20Total } 
          </div>
          
        </div>
      }

      {
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(17)
            else
              handleClick(15)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={alkanesImg} alt="bitmap" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              ALKANES
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { alkanesTotal } 
          </div>
          
        </div>
      }

{
        <div className="flex flex-col gap-2 px-4 py-5 rounded-md bg-customGray items-center cursor-pointer" 
          onClick={() => {
            if (location.pathname.includes('/profile')) 
              handleClick(18)
            else
              handleClick(16)
          }}
        >
          <div className="flex flex-row gap-3 items-center">
            <img src={op20Img} alt="bitmap" className="w-8 h-8" />
            <div className="text-white md:text-2xl text-xl font-bold">
              OP-20
            </div> 
          </div>
          <div className="text-3xl text-primary font-bold">
             { op20Total } 
          </div>
          
        </div>
      }
      </div>
    </div>
  )
}
